<a
  mat-icon-button
  (click)="toggle()"
  [matTooltip]="
    isBGN
      ? ('global.switchToEuro' | translate)
      : ('global.switchToLev' | translate)
  "
  [matTooltipPosition]="tooltipPosition"
  class="currency-toggle-btn"
  #tooltip="matTooltip"
  >
  @if (isBGN) {
    <mat-icon svgIcon="LEV" class="currency-toggle-btn-icon"></mat-icon>
  } @else {
    @if (!isBGN) {
      <mat-icon class="currency-toggle-btn-icon">euro</mat-icon>
    }
  }
</a>
